<template>
	<div class="prdList">
		<div class="title">推广产品</div>
		<crm-filter-panel label-width="100px" :groups="groups" @search="filterChange">
		</crm-filter-panel>
		<div v-loading="loading">
			<div class="main-prd" v-if="dataList.length">
				<prd
					v-for="(item, index) in dataList"
					:key="item.id"
					v-bind="item"
					:value="value"
					@check="check"
				></prd>
			</div>
			<div class="info" v-else>
				<img src="../../../assets/empty_images/zanwushuju.png" />
				<div>暂无数据</div>
			</div>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="currentPage"
			:page-sizes="[20, 30, 40, 50]"
			:page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalRecords"
		>
		</el-pagination>
	</div>
</template>

<script>
//todo:1.布局：产品和产品分类
import crmFilterPanel from '@/components/crm/crm-filterPanel.vue';
import prd from '@/components/adsOnlineAuto/com/prd';
import adsNewOnline from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
export default {
	props: {
		value: null,
	},
	data() {
		return {
			groups: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '请输入产品名称查询',
						prop: 'name',
						value: '',
						clearable: true,
					},
					{
						tagName: 'sky-select',
						placeholder: '上架状态',
						prop: 'online',
						value: '1',
						options: [
							{
								label: '未上架',
								value: '0',
							},
							{
								label: '已上架',
								value: '1',
							},
						],
					},
					{
						tagName: 'sky-select',
						placeholder: '发布状态',
						prop: 'deploy',
						value: '2',
						options: [
							{
								label: '未发布',
								value: '0',
							},
							{
								label: '发布中',
								value: '1',
							},
							{
								label: '已发布',
								value: '2',
							},
						],
					},
					{
						tagName: 'sky-select',
						placeholder: '按照排序顺序',
						prop: 'order',
						value: '',
						options: [
							{
								label: '按照排序顺序',
								value: 0,
							},
							{
								label: '按照更新日期',
								value: 1,
							},
							{
								label: '仅看置顶',
								value: 2,
							},
						],
					},
				],
			},
			dataList: [],
			currentPage: 1,
			totalRecords: 0,
			pageSize: 20,
			searchData: {},
			choose: [],
			loading: false,
		};
	},
	components: { crmFilterPanel, prd },

	computed: {
		queryParam() {
			return this.$route.query;
		},
	},
	watch: {
		value: {
			handler(val) {
				this.choose = val;
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		check(obj) {
			let flag = this.choose.some(item => {
				return obj.productId == item.productId;
			});
			if (flag) {
				this.choose = this.choose.filter(function (ele) {
					return ele.productId != obj.productId;
				});
			} else {
				this.choose.push(obj);
			}
			this.$emit('input', this.choose);
		},
		filterChange(val) {
			if (val.order == 2) {
				val.istop = 1;
			}
			if (val.order == 1) {
				val.sortName = 'weight';
				val.sortType = 'asc';
			}
			if (val.order == 0) {
				val.sortName = 'updateAt';
				val.sortType = 'asc';
			}
			if (!val.order) {
				val.sortName = '';
				val.sortType = '';
			}
			this.searchData = { ...val };
			this.getDataList();
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getDataList();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getDataList();
		},
		async getDataList() {
			try {
				this.loading = true;
				let currentPage = this.searchData.name ? 1 : this.currentPage;
				let params = {
					siteid: this.queryParam.projectId, //站点id
					online: '1',
					deploy: '2',
					...this.searchData,
					displayStart: currentPage,
					displayLength: this.pageSize,
				};
				let res = await adsNewOnline.productList(params);
				this.loading = false;
				this.totalRecords = res.data.page.totalRecords;
				if (res.data.data.length) {
					this.dataList = res.data.data;
				} else {
					this.dataList = [];
				}
			} catch (error) {
				this.loading = false;
			}
		},
	},
	mounted() {
		this.getDataList();
	},
};
</script>
<style lang="scss" scoped>
.prdList {
	::v-deep .panel-card {
		box-shadow: unset;
		padding: unset;
	}
	::v-deep .filterPanel {
		padding: unset;
	}
	::v-deep .btn-group {
		padding: unset;
	}
	.title {
		margin-top: 50px;
		font-size: 16px;
		font-weight: bold;
		color: rgba(0, 0, 0, 0.85);
	}
	.main-prd {
		display: grid;
		grid-template-columns: repeat(5, 18.5%);
		gap: 20px;
	}
	.info {
		padding: 30px;
		font-size: 15px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		img {
			width: 280px;
		}

		div {
			font-size: 15px;
			font-weight: 400;
			color: #666666;
			line-height: 21px;
		}
	}
}
</style>
